/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Assets
import { ArrowLeftIcon, ArrowRight2Icon } from 'assets/images/Icons'

// Contants
// import { EXTERNAL_URLS } from 'common/constants/apiUrls'

// Store
import { actions } from 'core/store'

// Hooks
import { useLocalStorage } from 'core/hooks/storage'

// Styled Elements
import {
  HeaderWrapper,
  HeaderTitle,
  HeaderInner,
  SubHeaderIconWrapper,
  // HeaderRightNavList,
  // HeaderRightNavListItem,
  // HeaderLogoutButton,
  // ProfileInfoWrapper,
  // ProfileInfoContainer,
  // ProfileFullName,
  // ProfileUserName,
  // ProfileUserRole,
  // HeaderSideMenuButton,
  // HeaderSideMenuIcon,
  // IconWrapper,
  SubHeaderWrapper,
  SubHeaderContent,
  // DropdownItemLink,
  // DropdownItemText,
  // DropdownItemDownload,
  // HasNotificationIcon,
} from './Header.elements'

// Views
import {
  LoaderLine,
  Button,
} from 'views/components'
import { useHistory } from 'react-router'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function Header(props) {
  // Destructure
  const { ui, actions, subHeader, pageTitle, link } = props

  // Store States
  const { showHeaderLoader, isProfileUpdated, } = ui

  // Store Actions
  const { setIsProfileUpdated, } = actions

  // Hooks
  const history = useHistory()
  const [userCredentials, setUserCredentials] = useLocalStorage('userCredentials', false)

  // Functions

  useEffect(() => {
    if (isProfileUpdated) {
      // Updating profile header
      setUserCredentials(JSON.parse(localStorage.getItem('userCredentials')))
      setIsProfileUpdated(false)
    }
  }, [isProfileUpdated,])

  return (
    <HeaderWrapper>
      <LoaderLine show={showHeaderLoader} />
      <HeaderInner>
        <HeaderTitle>
          {link ? (
            <Button onClick={() => history.push(link)}>
              <ArrowLeftIcon size={30} />
              {pageTitle || ''}
            </Button>
            ) : (
              pageTitle || ''
            )}
        </HeaderTitle>

      </HeaderInner>
      <SubHeaderWrapper>
        {subHeader && (
          <>
            <SubHeaderIconWrapper>
              <ArrowRight2Icon size={16} />
            </SubHeaderIconWrapper>
            <SubHeaderContent>{subHeader}</SubHeaderContent>
          </>
          )}
      </SubHeaderWrapper>
      <HeaderInner />
    </HeaderWrapper>
  )
}

// Default Props
Header.defaultProps = {
  subHeader: '',
  ui: {},
  actions: {},
  pageTitle: '',
}

// Proptypes Validation
Header.propTypes = {
  subHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  ui: PropTypes.shape({
    showHeaderLoader: PropTypes.bool,
    isProfileUpdated: PropTypes.bool,
    isNotifUpdated: PropTypes.bool,
  }),
  actions: PropTypes.shape({
    openAppSidebarDrawer: PropTypes.func,
    setIsProfileUpdated: PropTypes.func,
    setIsNotifUpdated: PropTypes.func,
  }),
  pageTitle: PropTypes.string,
  link: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
